// extracted by mini-css-extract-plugin
module.exports = {"register":"Register_register__1OQM7","error":"Register_error___9Ty2"};